import { render, staticRenderFns } from "./kpiRecordTable.vue?vue&type=template&id=5af2b640&"
import script from "./kpiRecordTable.vue?vue&type=script&lang=js&"
export * from "./kpiRecordTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports